"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _eventBus = require("./event-bus");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppMain',
  data: function data() {
    return {
      showModal: false,
      modalText: ''
    };
  },
  methods: {
    // 关闭异常详情对话框
    closeModal: function closeModal() {
      this.showModal = false;
    }
  },
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  },
  created: function created() {
    var _this = this;
    // 打开详情对话框
    _eventBus.EventBus.$on('open-dialog', function (value) {
      _this.showModal = value;
    });
    _eventBus.EventBus.$on('error-message', function (value) {
      _this.modalText = value;
    });
  }
};